import { Link } from 'react-router-dom';
import { formatPrice, type FeedItem } from '../lib/api';

const aspectClass = {
  '1:1': 'r11',
  '4:5': 'r45',
  '16:9': 'r169',
} as const;

function pickAspect(id: string): keyof typeof aspectClass {
  const n = id.charCodeAt(0) % 3;
  return n === 0 ? '1:1' : n === 1 ? '4:5' : '16:9';
}

export function ObjectCard({ item }: { item: FeedItem }) {
  const aspect = item.aspectRatio ?? pickAspect(item.id);
  const price = formatPrice(item.priceCents);
  return (
    <article className="object-card">
      <Link to={`/spin/${item.id}`} aria-label={`Spin ${item.title}`}>
        <img
          className={`poster ${aspectClass[aspect]}`}
          src={item.posterUrl ?? undefined}
          alt=""
          loading="lazy"
        />
      </Link>
      <div className="meta">
        <h2>{item.title}</h2>
        <div className="creator-row">
          <span className="avatar" aria-hidden>
            {(item.creator.displayName ?? item.creator.username ?? '?').slice(0, 1).toUpperCase()}
          </span>
          <span>@{item.creator.username}</span>
          {item.channel?.name ? <span>· {item.channel.name}</span> : null}
        </div>
        <div className="row">
          <Link className="btn primary" to={`/spin/${item.id}`}>
            Spin it
          </Link>
          {price ? <span className="muted">{price}</span> : null}
        </div>
      </div>
    </article>
  );
}
